import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RequireStudent({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <p style={{ padding: "1rem" }}>Loading…</p>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (user.role !== "student") {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
